export function normalizePathname(pathname) {
  if (!pathname) return '/'

  const withoutFragments = String(pathname).split(/[?#]/)[0] || ''
  let normalized = withoutFragments.replace(/\/{2,}/g, '/').replace(/\s+/g, '')

  if (!normalized.startsWith('/')) {
    normalized = `/${normalized}`
  }

  normalized = normalized.replace(/\/+$/, '')

  if (!normalized || normalized === '/') {
    return '/'
  }

  return normalized
}

export function matchesMenuPath(pathname, candidate) {
  if (!candidate) return false
  const normalizedCandidate = normalizePathname(candidate)
  const normalizedPathname = normalizePathname(pathname)

  if (normalizedPathname === normalizedCandidate) {
    return true
  }

  if (normalizedCandidate === '/') {
    return normalizedPathname === '/'
  }

  if (normalizedPathname.startsWith(`${normalizedCandidate}/`)) {
    return true
  }

  const candidateSegment = normalizedCandidate.replace(/^\//, '')
  if (!candidateSegment) return false

  const pathSegments = normalizedPathname.replace(/^\//, '').split('/')
  return pathSegments.includes(candidateSegment)
}
